import script from "./build-duration-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./build-duration-chart.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__